"use client";

import { XCloseIcon } from "@vetty/icons";
import styles from "./CloseIconButton.module.scss";
import type { CloseIconButtonProps } from "./CloseIconButton.types";

const CloseIconButton = ({
  "aria-label": ariaLabel = "Close",
  className = "",
  disabled,
  ...rest
}: CloseIconButtonProps) => {
  return (
    <button
      type="button"
      className={[styles["comp"], className].filter(Boolean).join(" ")}
      aria-label={ariaLabel}
      disabled={disabled}
      {...rest}
    >
      <XCloseIcon style={{ width: 20, height: 20 }} aria-hidden />
    </button>
  );
};

export { CloseIconButton };
